import { Message } from 'element-ui'
import { BigNumber } from 'bignumber.js'
import axios from 'axios'

export const toastMessage = (message, options) => {
  Message({
    message,
    center: true,
    offset: 300,
    duration: 1500,
    // iconClass: 'el-icon-warning-outline',
    customClass: 'msgToast',
    ...options
  })
}

export const setLocalStorage = (key, value) => {
  if (!key) return
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem(key, value)
}

export const getLocalStorage = (key) => {
  if (!key) return
  let value = window.localStorage.getItem(key)
  try {
    value = JSON.parse(value)
    return value
  } catch {
    return value
  }
}

export const removeLocalStorage = (key) => {
  if (!key) return
  window.localStorage.removeItem(key)
}

export const mergeAreaValue = (arr) => {
  arr.forEach((_) => {
    _.value = {
      name: _.name,
      code: _.code
    }
    _.children && mergeAreaValue(_.children)
  })
  return arr
}

export const getAreaList = async () => {
  // const { data, status } = await axios.get('http://10.10.10.160:9904/pcas-code.json')
  const { data, status } = await axios.get('/FrontEnd/pcas-code.json')
  const arr = status === 200 ? data : []
  // return mergeAreaValue(arr)
  return arr
}

export const bigAdd = (...numbers) => {
  return numbers
    .reduce((acc, curr) => acc.plus(new BigNumber(curr)), new BigNumber(0))
    .toNumber()
}

export const bigMinus = (...numbers) => {
  if (numbers.length === 0) return 0
  if (numbers.length === 1) return new BigNumber(numbers[0]).toNumber()
  if (numbers.length === 2 && !numbers[1]) return numbers[0]
  if (numbers.length === 2 && !numbers[0]) return -numbers[1]

  return numbers
    .slice(1)
    .reduce(
      (acc, curr) => acc.minus(new BigNumber(curr)),
      new BigNumber(numbers[0])
    )
    .toNumber()
}

export const bigMultiply = (...numbers) => {
  if (numbers.length === 0) return 0
  return numbers
    .reduce(
      (acc, curr) => acc.multipliedBy(new BigNumber(curr)),
      new BigNumber(1)
    )
    .toNumber()
}

export const bigDev = (...numbers) => {
  if (numbers.length === 0) return 0
  if (numbers.length === 1) return new BigNumber(numbers[0]).toNumber()

  return numbers
    .slice(1)
    .reduce(
      (acc, curr) => acc.dividedBy(new BigNumber(curr)),
      new BigNumber(numbers[0])
    )
    .toNumber()
}

export function throttle (fn, delay) {
  let timer = null
  return function (...args) {
    if (!timer) {
      timer = setTimeout(() => {
        fn.apply(this, args)
        timer = null
      }, delay)
    }
  }
}

export function debounce (func, delay) {
  let timer // 定义一个计时器

  return function (...args) {
    // 清除上一个计时器
    if (timer) clearTimeout(timer)

    // 创建新的计时器，在 delay 时间后执行函数
    timer = setTimeout(() => {
      func.apply(this, args) // 使用 apply 确保 this 和参数正确传递
    }, delay)
  }
}

// 格式化日期
function formatDate (dateString) {
  const date = new Date(dateString)

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export const toHome = () => (location.href = '/')

export const utils = {
  toastMessage,
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
  getAreaList,
  bigAdd,
  bigMinus,
  bigMultiply,
  bigDev,
  throttle,
  debounce,
  toHome,
  formatDate
}
